import { useCallback } from 'react';
import { parseAsBoolean, parseAsStringEnum, useQueryStates } from 'nuqs';
import {
  NewModelPcType,
  TotalOIPutCallImpactConfig,
  DEFAULT_TOTAL_OI_PC_IMPACT_CONFIG,
} from 'types';

const TOTAL_OI_PCI_QUERY_KEYS = {
  tpci_type: parseAsStringEnum<NewModelPcType>(
    Object.values(NewModelPcType),
  ).withDefault(DEFAULT_TOTAL_OI_PC_IMPACT_CONFIG.pcType),
  tpci_kl: parseAsBoolean.withDefault(
    DEFAULT_TOTAL_OI_PC_IMPACT_CONFIG.showKeyLevels,
  ),
};

export function useTotalOIPutCallImpactConfig(): [
  TotalOIPutCallImpactConfig,
  (patch: Partial<TotalOIPutCallImpactConfig>) => void,
] {
  const [params, setParams] = useQueryStates(TOTAL_OI_PCI_QUERY_KEYS);

  const config: TotalOIPutCallImpactConfig = {
    pcType: params.tpci_type,
    showKeyLevels: params.tpci_kl,
  };

  const updateConfig = useCallback(
    (patch: Partial<TotalOIPutCallImpactConfig>) => {
      const urlPatch: Partial<typeof params> = {};
      if (patch.pcType != null) {
        urlPatch.tpci_type = patch.pcType;
      }
      if (patch.showKeyLevels != null) {
        urlPatch.tpci_kl = patch.showKeyLevels;
      }
      void setParams(urlPatch);
    },
    [setParams],
  );

  return [config, updateConfig];
}
